import { Error } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const WarningIcon = ({ message, color }) => (
  <Tooltip arrow title={<h4>{message}</h4>}>
    <span>
      <Error style={{ color: color }} title={message} />
    </span>
  </Tooltip>
)

WarningIcon.propTypes = {
  message: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
}

export default WarningIcon
